import React, { useEffect, useState } from "react";
import MyMap from "../../Map/Views/MyMap";
import ReactDragListView from "react-drag-listview/lib/index.js";
import "./Sidebar.css";

export default function SidebarKatmanlar() {
  const [listData, setListData] = useState([]);
  const [show, setShow] = useState(false);
  const [reRender, setReRender] = useState(false);

  useEffect(() => {
    let layers = MyMap.getLayers()
      .getArray()
      .filter((d) => d.get("desc") === "katman");
    layers.sort((a, b) => b.getZIndex() - a.getZIndex());
    setListData(layers);
    setShow(true);
  }, []);

  const onClickEye = (layer, bool) => {
    layer.set("visible", bool);
    setReRender(!reRender);
  };

  const onChangeLayerOpacity = (layer, opacity) => {
    layer.set("opacity", opacity / 100);
    setReRender(!reRender);
  };

  const dragProps = {
    onDragEnd(fromIndex, toIndex) {
      if (fromIndex === toIndex) return;
      setShow(false);
      const firstZ = listData[toIndex].getZIndex();
      const secondZ = listData[fromIndex].getZIndex();
      listData[fromIndex].setZIndex(firstZ);
      listData[toIndex].setZIndex(secondZ);
      let layers = MyMap.getLayers().getArray();
      layers.sort((a, b) => b.getZIndex() - a.getZIndex());
      setListData(layers);
      setShow(true);
    },
    nodeSelector: "div.layer-item",
    handleSelector: ".drag-handle",
  };

  return (
    <div>
      <div className="sideBarFormTitle">Katmanlar</div>
      <div
        className="layerListContainer"
        style={{
          padding: "5px 10px",
          overflowY: "auto",
          maxHeight: "calc(100% - 60px)",
        }}
      >
        {show && (
          <ReactDragListView {...dragProps}>
            {listData.map((layer, i) => (
              <div
                key={i}
                className={`layer-item ${i % 2 === 0 ? "bgEven" : "bgOdd"}`}
                style={{
                  display: "grid",
                  gridTemplateColumns: "25px 1fr 80px 35px",
                  alignItems: "center",
                  padding: "4px 6px",
                  borderRadius: "4px",
                  marginBottom: "4px",
                  color: "white",
                }}
              >
                <div
                  className="drag-handle"
                  style={{
                    textAlign: "center",
                    cursor: "grab",
                    color: "rgba(255,255,255,0.9)",
                  }}
                >
                  <i className="fas fa-grip-lines"></i>
                </div>

                <div
                  className="test"
                  title={layer.get("name")}
                  style={{ fontWeight: "600" }}
                >
                  {layer.get("name")}
                </div>

                <div style={{ padding: "0 4px" }}>
                  <input
                    type="range"
                    min={0}
                    max={100}
                    value={layer.get("opacity") * 100}
                    onChange={(e) =>
                      onChangeLayerOpacity(layer, e.target.value)
                    }
                    style={{
                      width: "100%",
                      accentColor: "#09b9ff",
                      height: "3px",
                      cursor: "pointer",
                    }}
                  />
                </div>

                <div
                  onClick={() => onClickEye(layer, !layer.get("visible"))}
                  style={{
                    textAlign: "center",
                    cursor: "pointer",
                    fontSize: "16px",
                  }}
                >
                  {layer.get("visible") ? (
                    <i className="fas fa-eye" style={{ color: "#09b9ff" }}></i>
                  ) : (
                    <i
                      className="fas fa-eye-slash"
                      style={{ color: "#ff002e" }}
                    ></i>
                  )}
                </div>
              </div>
            ))}
          </ReactDragListView>
        )}
      </div>
    </div>
  );
}
